import { render } from "./StoreInfoModule.vue?vue&type=template&id=0d881d08&scoped=true"
import script from "./StoreInfoModule.vue?vue&type=script&lang=js"
export * from "./StoreInfoModule.vue?vue&type=script&lang=js"

import "./StoreInfoModule.vue?vue&type=style&index=0&id=0d881d08&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d881d08"]])

export default __exports__